<template>
  <rental-transfer type-vue="create" type-mission="transfert" />
</template>

<script>
import RentalTransfer from '@/components/driver/rentalCoupon/RentalTransfer';
export default {
  name: 'RentalTransferCreate',
  components: { RentalTransfer },
};
</script>
